import React, { useContext } from 'react';
import { useTheme } from '@mui/material/styles';
import { IconProps } from './iconProps';
import { UiContext } from 'shared/lib/contexts/uiContext';
import cx from 'classnames';
import { defaultSpacingPresets } from 'shared/hooks/useGetSpacing';

export default function IconTrash({
  extColor,
  isAutoscallable = true,
  sizeKey = '18x18',
  onClick,
  style,
}: IconProps) {
  const theme = useTheme();
  const fill = extColor || theme.palette.text.secondary;
  const {
    spacings: {
      icons: { [sizeKey]: size },
    },
  } = useContext(UiContext);

  const w = isAutoscallable ? size.w : defaultSpacingPresets.icons[sizeKey].w;
  const h = isAutoscallable ? size.h : defaultSpacingPresets.icons[sizeKey].h;

  return (
    <svg
      className={cx('icon', { 'icon-disabled': !onClick })}
      onClick={onClick}
      style={style}
      width={w}
      height={h}
      viewBox="0 0 18 18"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M6.86914 2.37598V3.12598H3.11914V4.62598H3.86914V14.376C3.86914 14.7738 4.02718 15.1553 4.30848 15.4366C4.58978 15.7179 4.97132 15.876 5.36914 15.876H12.8691C13.267 15.876 13.6485 15.7179 13.9298 15.4366C14.2111 15.1553 14.3691 14.7738 14.3691 14.376V4.62598H15.1191V3.12598H11.3691V2.37598H6.86914ZM6.86914 6.12598H8.36914V12.876H6.86914V6.12598ZM9.86914 6.12598H11.3691V12.876H9.86914V6.12598Z" />
    </svg>
  );
}
